import React, { useState, useEffect } from 'react';

interface UserAvatarProps {
  photoURL?: string | null;
  photo_url?: string | null;
  displayName?: string | null;
  display_name?: string | null;
  email?: string | null;
  className?: string;
  imgClassName?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  photoURL,
  photo_url,
  displayName,
  display_name,
  email,
  className = '',
  imgClassName = '',
  size = 'md'
}) => {
  const [imgError, setImgError] = useState(false);

  const rawPhoto = photoURL || photo_url || '';
  const name = displayName || display_name || '';

  // Reset error if photo URL changes
  useEffect(() => {
    setImgError(false);
  }, [rawPhoto]);

  // Dimensions based on size preset
  let sizeClasses = 'w-10 h-10 text-xs rounded-xl';
  if (size === 'sm') {
    sizeClasses = 'w-8 h-8 text-[10px] rounded-full';
  } else if (size === 'lg') {
    sizeClasses = 'w-12 h-12 text-sm rounded-2xl';
  } else if (size === 'xl') {
    sizeClasses = 'w-16 h-16 text-base rounded-2xl';
  }

  const initials = (name || email || 'U').trim().substring(0, 2).toUpperCase();

  return (
    <div className={`bg-gradient-to-tr from-emerald-500 to-indigo-500 flex items-center justify-center text-white font-bold uppercase shadow-inner overflow-hidden shrink-0 ${sizeClasses} ${className}`}>
      {rawPhoto && !imgError ? (
        <img
          src={rawPhoto}
          alt={name || 'User Profile'}
          className={`w-full h-full object-cover ${imgClassName}`}
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
};
